type ZodGlobalConfig = {
  jitless?: boolean;
};

const zodGlobal = globalThis as typeof globalThis & {
  __zod_globalConfig?: ZodGlobalConfig;
};

// Prevent Zod's browser eval probe from emitting CSP report-only violations.
zodGlobal.__zod_globalConfig = {
  ...zodGlobal.__zod_globalConfig,
  jitless: true,
};
